// extracted by mini-css-extract-plugin
module.exports = {"container_pages":"Pagination_container_pages__3GzI5","number_page":"Pagination_number_page__y-uMa","button_page":"Pagination_button_page__1VG3h"};